<template>
    <div>
        <Confirmalert :isShow="showToImConfirmalert" :content="toImConfirmalertContent"
            :confirmText="toImConfirmalertConfirmText" cancelText="取消" :onConfirm="toImConfirmalertOnConfirm"
            :onCancel="toImConfirmalertOnCancel">
            <v-card-text class="text-center confirmalert-conent" v-show="!$slots.default">
                <div>{{ toImConfirmalertContent }}</div>
                <div v-if="imUrlStatus == 2" class="confirmalert-error-tips">若无法跳转，您可以点击<span
                        class="confirmalert-error-tips-strong" @click="copyHref"> 复制链接 </span>打开</div>
                <div v-if="isShowIp && ip()" class="confirmalert-conent-ip">{{ ip() }}</div>
            </v-card-text>
        </Confirmalert>
    </div>
</template>

<script>
import {
    get as _get
} from 'lodash-es'
import axios from 'axios'
import Cookie from 'js-cookie'
import appConfigMixins from '@c/mixins/appConfig.mixins'
import any from '~/assets/tools/any.js'
import { originalinstance } from '~/api/http'
import {
    getCdnsByEnv,
    getTxtPath
} from '@c/changeLinedialog'
const {
    Decrypt
} = require('~/assets/tools/crypto')
const KEY_DOMAIN = require('~/assets/tools/key-domain')

export default {
    mixins: [appConfigMixins],
    data() {
        return {
            showToImConfirmalert: false,
            cdnUrlStatus: 0, //0未检测 1检测中 2检测到可用域名 3未检测到可用域名
            imUris: [],
            imUrlStatus: 0, //0未检测 1检测中 2检测到可用域名 3未检测到可用域名 4限制访问
            imDomain: '',
            imJumpHref: '',
            axiosCancels: []
        }
    },
    computed: {
        token() {
            let token = this.$store.state.user.token || Cookie.get('TOKEN')
            return token || ''
        },
        userInfo() {
            return this.$store.state.user.userInfo
        },
        toImConfirmalertContent() {
            const cdnUrlStatus = this.cdnUrlStatus
            const imUrlStatus = this.imUrlStatus
            if (cdnUrlStatus == 1) {
                return '获取CDN节点中...'
            } else if (cdnUrlStatus == 3) {
                return '未找到可用的CDN节点[imcbt]'
            } else if (imUrlStatus == 1) {
                return '获取聊天室域名节点中...'
            } else if (imUrlStatus == 2) {
                return '聊天室已就绪'
            } else if (imUrlStatus == 3) {
                return '未找到可用的聊天室域名节点[imabt]'
            } else if (imUrlStatus == 4) {
                return '访问受限[imipxz]'
            } else {
                return ''
            }``
        },
        isShowIp() {
            return this.cdnUrlStatus == 3 || this.imUrlStatus == 3 || this.imUrlStatus == 4
        },
        toImConfirmalertConfirmText() {
            const cdnUrlStatus = this.cdnUrlStatus
            const imUrlStatus = this.imUrlStatus
            if (imUrlStatus == 1 || cdnUrlStatus == 1) {
                return '请稍后' 
            } else if (imUrlStatus == 2) {
                return '前往'
            } else if (cdnUrlStatus == 3 || imUrlStatus == 3 || imUrlStatus == 4) {
                return '重试'
            } else {
                return ''
            }
        },
        actDomainIndex() {
            let actDomainIndex = -1
            try {
                actDomainIndex = this.imUris.findIndex(imApiDomain => imApiDomain == this.imDomain)
            } catch { }
            return actDomainIndex
        }
    },
    methods: {
        ip() {
            return window.returnCitySN ? window.returnCitySN.cip : ''
        },
        load() {
            this.reset()
            this.showToImConfirmalert = true
            this.checkCdn().then(() => {
                this.checkApiAddress()
            })
        },
        checkCdn() {
            const site_flag = _get($app.$store.state, 'sysParameter.sysParam.site_flag')
            const site_code = _get($app.$store.state, 'sysParameter.sysParam.site_code')
            const cdns = getCdnsByEnv(site_flag)
            const txtPath = getTxtPath(site_flag, site_code, 'im')
            const cndPromise = cdns.map(cdn => {
                const source = axios.CancelToken.source()
                this.axiosCancels.push(source)
                return new Promise((resolve, reject) => {
                        originalinstance.get(cdn + txtPath, {
                        cancelToken: source.token
                    }).then(res => {
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                })
            })
            this.cdnUrlStatus = 1
            return new Promise((resolve, reject) => {
                any(cndPromise).then(res => {
                    const domainData = Decrypt(res.data, KEY_DOMAIN.key, KEY_DOMAIN.iv)
                    const domains = JSON.parse(domainData).domains
                    let domainsArr = []
                    if (domains instanceof Array) {
                    domainsArr = domains.map(item => item.domain)
                    } else {
                    domainsArr = domains.split(',')
                    }
                    this.imUris = domainsArr
                    this.cdnUrlStatus = 2
                    resolve(domainsArr)
                }).catch(err => {
                    this.cdnUrlStatus = 3
                    reject(err)
                })
            })
        },
        checkApiAddress() {
            //检测可用域名
            const promiseList = this.imUris.map(imDomain => {
                return new Promise((resolve, reject) => {
                    originalinstance
                        .post(`${imDomain}/melody/api/v1/base/heartbeat`)
                        .then(res => {
                            const code = res.data ? res.data.code : ''
                            if (code == '12200' || code == '10008') {
                                resolve({ imDomain, code })
                            } else {
                                reject({ imDomain, code })
                            }
                        })
                        .catch(e => {
                            reject(e)
                        })
                })
            })
            this.imUrlStatus = 1
            any(promiseList)
                .then(({ imDomain, code }) => {
                    if (code == '12200') {
                        this.imDomain = imDomain
                        this.imUrlStatus = 2

                        this.imJumpHref = `${this.imDomain}?tk=${this.token}&islotterybet=n${this.actDomainIndex >= 0 ? `&imurlindex=${this.actDomainIndex}` : ''}`
                    } else if (code == '10008') {
                        this.imUrlStatus = 4
                    } else {
                        this.imUrlStatus = 3
                    }
                })
                .catch(e => {
                    this.imUrlStatus = 3
                })
        },
        toIM() {
            let loginTipsMode = 'toast'
            try {
                loginTipsMode = this.$store.state.app.appConfig.common_config.configValue.loginTipsMode || 'toast'
            } catch (e) {
                loginTipsMode = 'toast'
            }
            loginTipsMode = loginTipsMode == undefined ? 'toast' : loginTipsMode

            if (!this.token) {
                if (loginTipsMode == 'jumpLogin') {
                    this.$router.push('/login')
                } else {
                    this.$toast('请登录后操作')
                }

            } else if (this.userInfo && this.userInfo.memberType == 3) {
                this.$toast('试玩账号无此权限')
            } else if (this.userInfo && this.userInfo.isIm == 0) {
                try {
                    let tips_im = this.$store.state.sysParameter.sysParam.isIm_permission_type_tip

                    this.$toast(tips_im)
                    this.$store.dispatch('user/getUserInfo')
                } catch (e) {
                    console.error('缺少IM提示语配置')
                }

            } else {
                this.load()
            }
        },
        toImConfirmalertOnConfirm() {
            const cdnUrlStatus = this.cdnUrlStatus
            const imUrlStatus = this.imUrlStatus
            if (imUrlStatus == 2) {
                if (!this.$tools.isQQBrowser()) {
                    window.open(this.imJumpHref)
                } else {
                    window.location.href = this.imJumpHref
                }

                this.showToImConfirmalert = false
            } else if (cdnUrlStatus == 3 || imUrlStatus == 3 || imUrlStatus == 4) {
                this.toIM()
            }
        },
        toImConfirmalertOnCancel() {
            this.reset()
            this.showToImConfirmalert = false
        },
        copyHref() {
            this.$copyText(this.imJumpHref).then(() => {
                this.$toast('复制成功')
            })
        },
        reset() {
            this.axiosCancels.forEach(item => {
                item.cancel()
            })
            this.cdnUrlStatus = 0
            this.imUris = []
            this.imUrlStatus = 0
            this.imDomain = ''
            this.imJumpHref = ''
            this.axiosCancels = []
        },
    }
}
</script>

<style lang="scss" scoped>
.confirmalert-conent {
    color: #333;
    font-size: 14px;
    line-height: 1.5;
    padding: 0 20px 20px;
}

.confirmalert-conent-ip {
    color: #999;
}

.confirmalert-error-tips {
    color: #999;
    font-size: 12px;
}

.confirmalert-error-tips-strong {
    color: rgb(53, 127, 224);
}
</style>
